import { hotRankings } from '@/mocks/homepage';

export default function HotRankings() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="lg:w-[40%]">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] tracking-tight">
              每日热点
              <br />
              数据排行
            </h2>

            <div className="flex gap-0 mt-10 md:mt-14 divide-x divide-background-300">
              <div className="flex-1 pr-6">
                <p className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-primary-500 tracking-tight tabular-nums">
                  {hotRankings.todayReads}
                </p>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
                  {hotRankings.todayReadsLabel}
                </p>
              </div>
              <div className="flex-1 px-6">
                <p className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-primary-500 tracking-tight tabular-nums">
                  {hotRankings.realtimeDiscussions}
                </p>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
                  {hotRankings.realtimeDiscussionsLabel}
                </p>
              </div>
              <div className="flex-1 pl-6">
                <p className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-primary-500 tracking-tight tabular-nums">
                  {hotRankings.exclusiveScoops}
                </p>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
                  {hotRankings.exclusiveScoopsLabel}
                </p>
              </div>
            </div>
          </div>

          <div className="lg:w-[60%] relative h-[280px] md:h-[360px] lg:h-auto rounded-2xl overflow-hidden">
            <div className="absolute inset-0 bg-accent-100/60" />
            <div className="absolute top-[15%] left-[10%] w-40 h-32 rounded-2xl bg-accent-200/70 blur-sm" />
            <div className="absolute top-[35%] left-[30%] w-36 h-28 rounded-full bg-primary-100/60 blur-md" />
            <div className="absolute top-[10%] right-[15%] w-44 h-36 rounded-3xl bg-accent-300/50 blur-sm" />
            <div className="absolute bottom-[20%] right-[10%] w-32 h-40 rounded-2xl bg-accent-200/60 blur-md" />
            <div className="absolute bottom-[10%] left-[20%] w-48 h-24 rounded-full bg-primary-100/70 blur-sm" />
            <div className="absolute top-[50%] left-[45%] w-28 h-28 rounded-xl bg-accent-300/40 blur-md" />
          </div>
        </div>
      </div>
    </section>
  );
}